export default __webpack_public_path__ + "static/media/View Action Icon Component.f89eda3d.svg";